export const GENES = "5UTR,ORF1a,ORF1b,S,ORF3a,E,M,ORF6,ORF7a,ORF7b,ORF8,N,ORF10,3UTR,Non-coding region".split(",");
export const AA_SIZE = 3;
export const MAX_AA = 9937;
import {
  // PREVALENCE_ZERO_THRESHOLD,
  PREVALENCE_COLORS_CONTROL_PCTS,
  PREVALENCE_COLOR_ZERO_LIGHTMODE,
  PREVALENCE_COLORS_LIGHTMODE,
  // PREVALENCE_COLOR_LOW_LIGHTMODE, PREVALENCE_COLOR_HIGH_LIGHTMODE
} from './styles';
import { getColorFromArray, lerpColor } from './color';


const TAU = Math.PI * 2,
  START_ANGLE = TAU * 0.25;

const BY_GENOME = 1,
  BY_MUTATION = 2,
  BY_MUTATION_BLOCK = 3;


let nfc = (x)=>{
  return !x ? '' : x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


let crispifyPixel = n=>Math.round(n) + 0.5;





let getClosestMutation = (variantFnc, geneFnc, positionFnc, proximityFnc,
  variants, geneWedges, currentMutations)=>{
  let hring = null,
    hgene=null,
    // posPercent = -1,
    hpos = -1,
    hmut = null,
    closest = null,
    minD = 10000;
  hring = variants.filter(variantFnc)[0];
  let wedge = geneWedges.filter(geneFnc).pop();
  if (wedge) {
    hgene = wedge.name;
    // posPercent = positionFnc(wedge);
  }
  currentMutations.filter(({mutation})=>mutation.gene === hgene).forEach(item=>{
    // let d = Math.abs(item.mutation.position - hpos);
    let d = proximityFnc(item);
    if (d < minD) {
      minD = d;
      closest = item;
    } else if (d === minD) {
      /*
      different mutations can be at
      the same location, like S:L452Q and S:L452R. check which is
      most prominent for this variant.
      */
      if (hring) {
        let c = hring.mutations[closest.mutation.name],
          i = hring.mutations[item.mutation.name];
        if (i && (!c || c.count < i.count)) {
          // console.log(hring.name, closest.mutation.name, c, 'with', item.mutation.name, i)
          closest = item;
        }
      }
    }
  });
  if (closest) {
    hgene = closest.mutation.gene;
    hpos = closest.mutation.position;
    hmut = closest;
  }
  return {hgene, hpos, hmut, hring};
};



let drawRadialLabel = (ctx, label, angle, cosA, sinA, xOffset, yOffset, labelRadius, withBG)=>{
  let tx = xOffset || 0, ty = 0, tw, bgMod = 1;
  let baselineShift = 0;
  ctx.save();
  ctx.translate(cosA * labelRadius, sinA * labelRadius);
  if (angle >= START_ANGLE && angle < TAU * 0.75) {
    ctx.rotate(angle + Math.PI);
    baselineShift = 2;
  } else {
    ctx.textAlign = 'right';
    ctx.rotate(angle);
    tx = -tx;
    ty = 10;
    bgMod = -1;
    baselineShift = -6;
  }
  if (withBG) {
    ctx.globalAlpha *= 0.2;
    tw = bgMod * (ctx.measureText(label).width + 7);
    ctx.fillRect(tx + 1, ty - 10 + baselineShift, tw, 14);
    ctx.globalAlpha *= 5;
    tx += bgMod * 3;
  }
  ctx.fillText(label, tx, ty + baselineShift + yOffset);
  ctx.restore();
};

let drawRotatedLabel = (ctx, label, x, y, angle)=>{
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(angle);
  ctx.fillText(label, 0, 0);
  ctx.restore();
};

let getPrevalenceColor = pct=>{
  // pct /= 100;
  let rgb = PREVALENCE_COLOR_ZERO_LIGHTMODE;
  if (pct > 0) {
    let lowPct, highPct,
      low = PREVALENCE_COLORS_LIGHTMODE[0],
      high = PREVALENCE_COLORS_LIGHTMODE[1];
    for (let i = 1; i < PREVALENCE_COLORS_CONTROL_PCTS.length; i++) {
      lowPct = PREVALENCE_COLORS_CONTROL_PCTS[i-1];
      highPct = PREVALENCE_COLORS_CONTROL_PCTS[i];
      if (pct <= highPct && pct > lowPct) {
        low = PREVALENCE_COLORS_LIGHTMODE[i-1];
        high = PREVALENCE_COLORS_LIGHTMODE[i];
        pct = (pct - lowPct) / (highPct - lowPct);
      }
    }
    rgb = lerpColor(low, high, pct);
  }
  return getColorFromArray(rgb);
}





export { getClosestMutation, drawRadialLabel, drawRotatedLabel,
  crispifyPixel, nfc, getPrevalenceColor,
  TAU, START_ANGLE, BY_GENOME, BY_MUTATION, BY_MUTATION_BLOCK };